import { wrapSubstringWithHTMLTag } from "../../../../utils/utils";
import { KEYWORDS } from "../../../../variables/Constants";
export function getQuestionSet(array, topic, version) {
  let Question_Set = [];
  for (var index = 0; index < array.length; index++) {
    if (
      (array[index].topic === topic &&
        array[index].productVersions.includes(version)) ||
      (array[index].topic === topic && version === "All")
    ) {
      Question_Set.push(array[index]);
    }
  }
  return Question_Set;
}

export function getQuestionSetScenario(array, topic, ScenarioName) {
  let Question_Set = [];
  for (var index = 0; index < array.length; index++) {
    if (
      array[index].topic === topic &&
      array[index].scenarioId === ScenarioName
    ) {
      Question_Set.push(array[index]);
    }
  }
  return Question_Set;
}

export function versionCompatible(versionList, version) {
  try {
    let array = versionList.replace(/\s/g, "").split(",");
    let element = version.replace(/\s/g, "").toString();
    if (array === undefined) {
      return new Error("No details about version");
    }
    for (var i = 0; i < array.length; i++) {
      if (array[i] === element) {
        return true;
      }
    }
    return false;
  } catch (error) {
    return new Error("No details about version");
  }
}

export function getValue(sheetData, row, col) {
  if (sheetData[0].rowData[row] !== undefined) {
    if (sheetData[0].rowData[row].values[col] !== undefined) {
      if (sheetData[0].rowData[row].values[col].formattedValue !== undefined) {
        return sheetData[0].rowData[row].values[col].formattedValue;
      } else {
        return null;
      }
    } else {
      return null;
    }
  } else {
    return null;
  }
}
// Use For Arrange MCQ Quesiton
export function getMCQQuestion(SheetData, row, Sheettitle) {
  let QuestionDataIndex = [1, 2, 3, 4, 5, 12, 14, 15, 16, 17, 18, 19, 20];
  QuestionDataIndex.forEach(index => {
    if (getValue(SheetData, row, index) === null) {
      return new Error(
        "Empty Cell In QUESTION_POOL Sheet . Row : " +
          (row + 1) +
          " Col : " +
          (index + 1)
      );
    }
  });
  var QuestionData = {
    questionId: parseInt(getValue(SheetData, row, 0), 10),
    state: getValue(SheetData, row, 1),
    topic: getValue(SheetData, row, 2),
    similarityId: getValue(SheetData, row, 3),
    productVersions: getValue(SheetData, row, 4)
      .replace(/\s/g, "")
      .split(","),
    question: wrapSubstringWithHTMLTag(KEYWORDS, getValue(SheetData, row, 5), "strong"),
    numberOfAnswers: parseInt(getValue(SheetData, row, 13), 10),
    isMultiple: getValue(SheetData, row, 14) === "TRUE",
    isSample: getValue(SheetData, row, 15) === "TRUE",
    createdBy: getValue(SheetData, row, 16),
    dateCreated: getValue(SheetData, row, 17),
    verifiedBy: getValue(SheetData, row, 18),
    dateVerified: getValue(SheetData, row, 19),
    group: getValue(SheetData, row, 20),
    sheetId: "QUESTION_POOL!A" + (row + 1)
  };
  let Answer = [];
  let NumberOfAnswer = parseInt(getValue(SheetData, row, 12), 10);
  if (NumberOfAnswer < 2) {
    return new Error(
      "Atleast two answer required: " + row + " In " + Sheettitle
    );
  }
  var CorrectCount = 0;
  for (var AnswerIndex = 0; AnswerIndex < NumberOfAnswer; AnswerIndex++) {
    if (IsCorrect(SheetData, row, AnswerIndex, 6)) {
      CorrectCount += 1;
    }
    if (CorrectCount > 1) {
      if (!QuestionData.isMultiple) {
        return new Error(
          `Single selection question cannot hold multiple answers. Row: ${row} in ${Sheettitle}`
        );
      }
    }
    Answer[AnswerIndex] = {
      answer: getValue(SheetData, row, 6 + AnswerIndex),
      position: parseInt(getPosition(SheetData, row, AnswerIndex, 6), 10),
      isCorrect: IsCorrect(SheetData, row, AnswerIndex, 6)
    };
  }
  if (CorrectCount < 1) {
    return new Error(
      "Atleast one answer should be in a Question. Check Row : " +
        row +
        " In " +
        Sheettitle
    );
  }
  if (CorrectCount < 2 && QuestionData.isMultiple) {
    return new Error(
      "Not Enough Correct Answer Count Question is Multiple Selection. Check Row : " +
        row +
        " In " +
        Sheettitle
    );
  }
  QuestionData["answer"] = Answer;
  return QuestionData;
}

// Use For Arrange MCQ Quesiton
export function getSCENARIOQuestion(SheetData, row, Sheettitle) {
  let QuestionDataIndex = [1, 2, 3, 4, 5, 12, 14, 15, 16, 17, 18, 19];
  QuestionDataIndex.forEach(index => {
    if (getValue(SheetData, row, index) === null) {
      return new Error(
        "Empty Cell In QUESTION_POOL Sheet . Row : " +
          (row + 1) +
          " Col : " +
          (index + 1)
      );
    }
  });

  var QuestionData = {
    questionId: parseInt(getValue(SheetData, row, 0), 10),
    state: getValue(SheetData, row, 1),
    topic: getValue(SheetData, row, 2),
    similarityId: getValue(SheetData, row, 3),
    scenarioId: getValue(SheetData, row, 4),
    productVersions: getValue(SheetData, row, 5)
      .replace(/\s/g, "")
      .split(","),
    question: getValue(SheetData, row, 6),
    numberOfAnswers: parseInt(getValue(SheetData, row, 14), 10),
    isMultiple: getValue(SheetData, row, 15) === "TRUE",
    isSample: getValue(SheetData, row, 16) === "TRUE",
    createdBy: getValue(SheetData, row, 17),
    dateCreated: getValue(SheetData, row, 18),
    verifiedBy: getValue(SheetData, row, 19),
    dateVerified: getValue(SheetData, row, 20),
    sheetId: "QUESTION_POOL!A" + (row + 1)
  };

  let Answer = [];
  let NumberOfAnswer = parseInt(getValue(SheetData, row, 13), 10);
  if (NumberOfAnswer < 2) {
    return new Error(
      "Atleast two answer required: " + row + " In " + Sheettitle
    );
  }
  var CorrectCount = 0;
  for (var AnswerIndex = 0; AnswerIndex < NumberOfAnswer; AnswerIndex++) {
    if (IsCorrect(SheetData, row, AnswerIndex, 7)) {
      CorrectCount += 1;
    }
    if (CorrectCount > 1) {
      if (!QuestionData.isMultiple) {
        return new Error(
          `Single selection question cannot hold multiple answers. Row: ${row} in ${Sheettitle}`
        );
      }
    }
    Answer[AnswerIndex] = {
      answer: getValue(SheetData, row, 7 + AnswerIndex),
      position: parseInt(getPosition(SheetData, row, AnswerIndex, 7), 10),
      isCorrect: IsCorrect(SheetData, row, AnswerIndex, 7)
    };
  }
  if (CorrectCount < 1) {
    return new Error(
      "Atleast one answer should be in a Question. Check Row : " +
        row +
        " In " +
        Sheettitle
    );
  }
  if (CorrectCount < 2 && QuestionData.isMultiple) {
    return new Error(
      "Not Enough Correct Answer Count Question is Multiple Selection. Check Row : " +
        row +
        " In " +
        Sheettitle
    );
  }
  QuestionData["answer"] = Answer;
  return QuestionData;
}

// Use For Arrange PRACTICAL Quesiton
export function getPRACTICALQuestion(SheetData, row, Sheettitle) {
  let QuestionDataIndex = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
  QuestionDataIndex.forEach(index => {
    if (getValue(SheetData, row, index) === null) {
      return new Error(
        "Empty Cell In QUESTION_POOL Sheet . Row : " +
          (row + 1) +
          " Col : " +
          (index + 1)
      );
    }
  });

  var QuestionData = {
    questionId: parseInt(getValue(SheetData, row, 0), 10),
    state: getValue(SheetData, row, 1),
    topic: getValue(SheetData, row, 2),
    similarityId: getValue(SheetData, row, 3),
    questionOrder: parseInt(getValue(SheetData, row, 4), 10),
    productVersions: getValue(SheetData, row, 5)
      .replace(/\s/g, "")
      .split(","),
    question: getValue(SheetData, row, 6),
    isSample: getValue(SheetData, row, 7) === "TRUE",
    createdBy: getValue(SheetData, row, 8),
    dateCreated: getValue(SheetData, row, 9),
    verifiedBy: getValue(SheetData, row, 10),
    dateVerified: getValue(SheetData, row, 11),
    sheetId: "QUESTION_POOL!A" + (row + 1)
  };
  return QuestionData;
}

export function IsCorrect(sheetData, row, col, Offset) {
  if (
    sheetData[0].rowData[row].values[col + Offset].userEnteredFormat ===
      undefined ||
    sheetData[0].rowData[row].values[col + Offset].userEnteredFormat
      .textFormat === undefined ||
    sheetData[0].rowData[row].values[col + Offset].userEnteredFormat.textFormat
      .bold === undefined ||
    sheetData[0].rowData[row].values[col + Offset].userEnteredFormat.textFormat
      .bold === false
  ) {
    return false;
  }
  return sheetData[0].rowData[row].values[col + Offset].userEnteredFormat
    .textFormat.bold;
}
export function getPosition(sheetData, row, col, offset) {
  if (
    sheetData[0].rowData[row].values[col + offset].userEnteredFormat ===
      undefined ||
    sheetData[0].rowData[row].values[col + offset].userEnteredFormat
      .textFormat === undefined ||
    sheetData[0].rowData[row].values[col + offset].userEnteredFormat.textFormat
      .underline === undefined ||
    sheetData[0].rowData[row].values[col + offset].userEnteredFormat.textFormat
      .underline === false
  ) {
    return null;
  }

  return col + 1;
}

export function getTopics(CategoryData, CategoryName) {
  var CurrentTopicsList = [];
  CategoryData.forEach(CategoryElement => {
    if (CategoryElement.category === CategoryName) {
      CurrentTopicsList = CategoryElement.topics;
      return CurrentTopicsList;
    }
  });
  return CurrentTopicsList;
}
